import { useContext, useMemo } from "react";
import { AvisConstants } from "../../../../../data/avisConstants";
import { CreationNumberInfo } from "../../../../../generated/data-contracts";
import { AvisSection } from "../../../../shared/components/form";
import {
  AvisSimpleTable,
  IColumnConfig,
} from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationNumbersProps {
  data: CreationNumberInfo[] | undefined;
}

export function CreationNumbers(props: Readonly<ICreationNumbersProps>) {
  const { res } = useContext(AvisContext);
  const { data } = props;
  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "creationNumberName",
        translation: res("authors_Creation_Section_Numbers_column_Type"),
      },
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "number",
        translation: res("authors_Creation_Section_Numbers_column_Number"),
      },
    ];
  }, [res]);
  if (!data) return; //Do not draw section if is not defined

  return (
    <AvisSection
      collapsable
      title={res("authors_Creation_Section_Numbers_Title")}
      textToDisplayKey="portal_RH_CreationCard_Numbers"
    >
      <AvisSimpleTable<CreationNumberInfo>
        columnMetadata={columnMetadata}
        data={data}
        columnWidths={[30, 70]}
      />
    </AvisSection>
  );
}
